import React from "react"
import PropTypes from "prop-types"
import AppBar from "@material-ui/core/AppBar"
import Toolbar from "@material-ui/core/Toolbar"
import IconButton from "@material-ui/core/IconButton"
import Icon from "@material-ui/core/Icon"

import { fade } from "@material-ui/core/styles/colorManipulator"
import { Container } from "ui-Grid"
import Collapse from '@material-ui/core/Collapse';

export const styleSheet = theme => ({
  root: {
    flexShrink: 0,
  },

  title: {
    ...theme.typography.subheading,

    color: "inherit",
    flex: 1,
  },

  container: { position: "relative" },

  toolbar: {
    [theme.breakpoints.down("xs")]: {
      minHeight: 48,
    },

    "& > div": {
      display: "flex",
      // overflow: "hidden",
    },
  },

  menuIcon: {
    marginLeft: theme.spacing.unit * -2,
    marginRight: theme.spacing.unit * 2,

    [theme.breakpoints.down("sm")]: {
      marginRight: theme.spacing.unit,
    },
  },

  tools: {
    alignItems: "center",

    "& > div": { display: "flex" },
  },

  colorSecondary: {
    "& $toolbar": {
      color: fade(theme.palette.getContrastText(theme.palette.secondary.main), 0.56),
    },
  },

  colorInherit: {
    "& $toolbar": {
      color: theme.palette.secondary.main,
    },
  },
})

export class MainAppBar extends React.Component {
  static propTypes = {
    classes: PropTypes.object,
    color: PropTypes.oneOf(["inherit", "secondary"]),
    fullWidth: PropTypes.bool,
    narrow: PropTypes.bool,
    position: AppBar.Naked.propTypes.position,
    scrolled: PropTypes.bool,
    theme: PropTypes.object,
    title: PropTypes.node,
    titleIn: PropTypes.bool,
    tools: PropTypes.node,
    wide: PropTypes.bool,

    onMenuClick: PropTypes.func,
  }

  static defaultProps = {
    position: "static",
    color: "secondary",
  }

  static uiName = "MainAppBar"

  _renderTitleComponent(title, titleIn) {
    let el = title

    if (titleIn !== undefined) {
      el = <Collapse in={titleIn}>{el}</Collapse>
    }

    return el
  }

  render() {
    const {
      children,
      classes,
      color,
      fullWidth,
      narrow,
      position,
      scrolled,
      theme,
      title,
      titleIn,
      tools,
      wide,

      onMenuClick,

      ...otherProps
    } = this.props

    const className = classnames(
      classes.root,
      {
        [classes.colorSecondary]: color === "secondary",
        [classes.colorInherit]: color === "inherit",
      },
      this.props.className
    )

    return (
      <div {...otherProps} className={className}>
        <AppBar position={position} elevation={0} color={color}>
          <div className={classes.container}>
            <Container fullWidth={fullWidth} wide={wide} narrow={narrow}>
              <Toolbar disableGutters className={classes.toolbar}>
                {onMenuClick && (
                  <div className={classes.menuIcon}>
                    <IconButton color="inherit" onClick={onMenuClick}>
                      <Icon>menu</Icon>
                    </IconButton>
                  </div>
                )}
                <div className={classes.title}>{this._renderTitleComponent(title, titleIn)}</div>
                <div className={classes.tools}>{children}</div>
              </Toolbar>
            </Container>
          </div>
        </AppBar>
      </div>
    )
  }
}

import { withStyles } from "@material-ui/core/styles"
import classnames from "classnames"

export default withStyles(styleSheet)(MainAppBar)



// WEBPACK FOOTER //
// ../ui-kit/src/components/ui-MainAppBar/MainAppBar.js